import * as React from "react";
import type { SVGProps } from "react";

const AccorPlusLogoNoTagline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="56"
    height="34"
    viewBox="0 0 56 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.2824 33.8569L39.4784 31.7422C40.4283 31.5269 41.0079 30.9897 41.0079 30.055C41.0079 28.999 40.0996 28.47 38.9491 28.47H35.3437V33.8569H36.2997V31.8186H38.444L40.096 33.8569H41.2824ZM36.2998 29.3061H38.9757C39.6348 29.3061 40.0283 29.6107 40.0283 30.1207C40.0283 30.6444 39.6152 30.9827 38.9757 30.9827H36.2998V29.3061Z"
      fill="#050033"
    />
    <path
      d="M2.82452 28.47L0.00459737 33.8569H1.08599L1.68747 32.6572H4.89882L5.5003 33.8569H6.60633L3.78641 28.47H2.82452ZM2.10659 31.8212L3.29307 29.4546L4.47955 31.8212H2.10659Z"
      fill="#050033"
    />
    <path
      d="M11.6634 29.1786C12.5624 29.1786 13.3036 29.5128 13.6837 30.0996L14.4548 29.5888C13.9149 28.8429 12.9597 28.3271 11.6634 28.3271C9.5679 28.3271 8.36411 29.6747 8.36411 31.1635C8.36411 32.6523 9.5679 34 11.6634 34C12.9598 34 13.9149 33.4844 14.4548 32.7385L13.6837 32.2276C13.3036 32.8145 12.5624 33.1485 11.6634 33.1485C10.2545 33.1485 9.34428 32.3693 9.34428 31.1636C9.34428 29.9579 10.2545 29.1786 11.6634 29.1786Z"
      fill="#050033"
    />
    <path
      d="M20.3458 29.1786C21.2448 29.1786 21.986 29.5128 22.3661 30.0996L23.1372 29.5888C22.5973 28.8429 21.6421 28.3271 20.3458 28.3271C18.2503 28.3271 17.0465 29.6747 17.0465 31.1635C17.0465 32.6523 18.2503 34 20.3458 34C21.6422 34 22.5973 33.4844 23.1372 32.7385L22.3661 32.2276C21.986 32.8145 21.2448 33.1485 20.3458 33.1485C18.9369 33.1485 18.0267 32.3693 18.0267 31.1636C18.0267 29.9579 18.9369 29.1786 20.3458 29.1786Z"
      fill="#050033"
    />
    <path
      d="M29.029 28.3271C26.9335 28.3271 25.7297 29.6747 25.7297 31.1635C25.7297 32.6523 26.9335 33.9999 29.029 33.9999C31.1245 33.9999 32.3283 32.6523 32.3283 31.1635C32.3283 29.6747 31.1245 28.3271 29.029 28.3271ZM29.029 33.1577C27.6202 33.1577 26.7099 32.3749 26.7099 31.1635C26.7099 29.952 27.6202 29.1693 29.029 29.1693C30.4379 29.1693 31.3481 29.9521 31.3481 31.1635C31.3481 32.3748 30.4379 33.1577 29.029 33.1577Z"
      fill="#050033"
    />
    <path
      d="M32.1502 24.0065H28.6233C27.137 24.0065 26.3891 23.6849 25.8441 22.9839C25.2635 22.237 25.2635 21.0992 25.2635 20.021V0.0102575H29.7976V20.6631C29.7976 22.298 29.9837 23.468 32.1503 23.9343V24.0067L32.1502 24.0065Z"
      fill="#050033"
    />
    <path
      d="M22.9793 24.0031H17.3053L13.1344 15.4397C10.8578 16.659 9.55904 19.4827 7.25046 21.3477C6.07422 22.298 4.69749 23.1452 2.98181 23.7183C2.20518 23.9776 0.885772 24.313 0.389108 24.3616C0.18183 24.3818 0.0358911 24.3736 0.00501404 24.2998C-0.0188014 24.2428 0.0383836 24.1991 0.259508 24.094C0.511647 23.9739 1.55357 23.5491 2.20642 23.1008C3.02141 22.5412 3.4883 21.9358 3.525 21.4689C3.30069 20.6907 1.70477 18.9633 3.33738 15.7938C3.92321 14.6565 4.42985 13.8381 4.79276 13.0155C5.20967 12.0706 5.50459 10.7395 5.60498 9.75023C5.61079 9.69253 5.62131 9.6954 5.6533 9.72745C6.44835 10.5192 9.52954 13.6448 9.08411 16.7517C10.1086 16.3638 11.8855 15.1863 12.7049 14.5579C13.5697 13.8947 14.1334 13.2027 15.0495 13.1872C15.8699 13.1735 15.9405 13.5598 16.5939 13.6448C16.7557 13.6658 16.9953 13.6348 17.1191 13.5751C17.1693 13.5509 17.157 13.4969 17.0811 13.4793C16.1901 13.2722 15.9768 12.5569 14.825 12.5569C13.792 12.5569 12.9696 13.494 12.3741 13.8788L9.46045 7.89668C8.24185 5.39477 8.61389 3.57655 11.2884 0L22.9793 24.0031Z"
      fill="#050033"
    />
    <path
      d="M41.2826 24.0065H37.7557C36.2695 24.0065 35.5215 23.6849 34.9765 22.9839C34.3959 22.237 34.3959 21.0992 34.3959 20.021V0.0102575H38.93V20.6631C38.93 22.298 39.1161 23.468 41.2828 23.9343V24.0067L41.2826 24.0065Z"
      fill="#050033"
    />
    <path
      d="M52.1274 14.1513H49.7126C48.6949 14.1513 48.1829 14.3715 47.8097 14.8515C47.4122 15.3629 47.4122 16.1418 47.4122 16.8802V18.842H50.5166V16.4407C50.5166 15.3213 50.644 14.5201 52.1275 14.2009L52.1274 14.1513Z"
      fill="#050033"
    />
    <path
      d="M56 13.533H41.9522V10.6406H47.4119V5.17488H50.5163V10.6406H56V13.533Z"
      fill="#050033"
    />
  </svg>
);
export default AccorPlusLogoNoTagline;
